import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { selectConfig } from '../config/selectors';
import {
  getConfig,
  getConfigSucceeded,
  getConfigFailed,
  updateConfig,
  updateConfigSucceeded,
  updateConfigFailed,
  updateConfigOnboardingSettings,
  updateConfigOnboardingSettingsSucceeded,
  updateConfigOnboardingSettingsFailed
} from './slice';

import { onGetConfig, onUpdateConfig } from './api';

function* getConfigWorker() {
  try {
    const response = yield call(onGetConfig);
    yield put(getConfigSucceeded(response?.data));
  } catch {
    yield put(getConfigFailed());
  }
}

function* updateConfigWorker({ payload }) {
  const { config, callback } = payload;
  try {
    const response = yield call(onUpdateConfig, config);
    yield put(updateConfigSucceeded(response?.data));
    callback?.();
  } catch {
    yield put(updateConfigFailed());
  }
}

export function* updateConfigOnboardingSettingsWorker({ payload }) {
  const { step, dataSource, importDone } = payload;
  try {
    const config = yield select(selectConfig);
    const updatedConfig = {
      ...config,
      ...(step !== undefined && { onboarding_current_step: step }),
      ...(dataSource !== undefined && { onboarding_selected_import_source: dataSource }),
      ...(importDone !== undefined && { onboarding_oqio_import_done: importDone })
    };
    const response = yield call(onUpdateConfig, updatedConfig);
    yield put(updateConfigOnboardingSettingsSucceeded(response?.data));
  } catch {
    yield put(updateConfigOnboardingSettingsFailed());
  }
}

export default function* configSagas() {
  yield all([
    takeLatest(getConfig.type, getConfigWorker),
    takeLatest(updateConfig.type, updateConfigWorker),
    takeLatest(updateConfigOnboardingSettings.type, updateConfigOnboardingSettingsWorker)
  ]);
}
